import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=2c50c060&scoped=true&"
import script from "./FileSelect.vue?vue&type=script&lang=js&"
export * from "./FileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50c060",
  null
  
)

export default component.exports
import {QFile,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QFile,QIcon})
